export const GET_CART = "GET_CART";
export const COUPON_DATA = "COUPON_DATA";
export const HANDLE_SPECIAL_INPUT="HANDLE_SPECIAL_INPUT"
export const HANDLE_ALT_NUM = "HANDLE_ALT_NUM"
export const SAVE_DISCOUNT="SAVE_DISCOUNT"
export const DONATION_AMOUNT="DONATION_AMOUNT"
export const INCREMENT_DONATION="INCREMENT_DONATION"
export const DECREMENT_DONATION="DECREMENT_DONATION"
export const RESET_DONATION="RESET_DONATION"
export const DONATION_DATA = "DONATION_DATA";
export const DONATION_ITEMS = "DONATION_ITEMS";
export const ADD_DONATION_ITEM = "ADD_DONATION_ITEM"
export const UPDATE_DONATION_ITEM = "UPDATE_DONATION_ITEM"
export const RESET_CUS_DONATION = "RESET_CUS_DONATION"
